import type { IPermissionModel } from "models/auth/entities/PermissionModel";
import type { PaginatedResponseModel } from "models/shared/PaginatedResponseModel";
import type { IAdministratorModel } from "models/user/administrator/entities/AdministratorModel";


export function isOwnPermissionsListResponseModel(response: any): response is IPermissionModel[] {
    return (
        response !== null &&
        typeof response === 'object' &&
        Array.isArray(response)
    );
}

export function isPaginatedAdministratorResponseModel(response: any): response is PaginatedResponseModel<IAdministratorModel> {
    return (
        response !== null &&
        typeof response === 'object' &&
        Array.isArray(response.content)
    );
}


export function isAdministratorResponseModel(response: any): response is IAdministratorModel {
    return (
        response !== null &&
        typeof response === 'object'
    );
}

